import BvBadge, { type BvBadgeArgs } from 'volta/components/bv-badge';
import BvIcon, { type BvIconSignature } from 'volta/components/bv-icon';
import BvInline from 'volta/components/bv-inline';
import BvText from 'volta/components/bv-text';

import type { TOC } from '@ember/component/template-only';

interface Signature {
  Args: {
    option: {
      key: string;
      label?: string;
    };
  };
}

const Item: TOC<Signature> = <template>
  <BvInline @gap='2' @blockAlign='center' @wrap={{false}}>
    <BvBadge @color='primary' @text={{@option.key}} />
    <BvText @text={{@option.label}} class='u-ellipsis' />
  </BvInline>
</template>;

export default Item;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'CurrencySelect::Item': typeof Item;
    'currrency-select/item': typeof Item;
  }
}
